/*
 * @Author: hfxie
 * @Date: 2022-08-17 14:37:30
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2023-09-06 14:54:19
 * @Description: 常量:交互自定义事件接口·我调用服务端·方法名
 */

const DEMO = "xxxx"; // 示例出去的常量方法名
const RESET_STATUS = "gtRestData"; // 重置·解决苍穹按钮多次同功能请求无效情况

const CUSTOM_INIT = "custom_init";
const GET_FILTER = "getFilter"; // 获取筛选结果
const UPDATE_FILTERSTATUS = "updateFilterstatus"; // 更新筛选状态值
const OPEN_SEARCH = "getSearch"; // 打开苍穹搜索条件

const OPT_ADD = "addTempClass"; // 行操作-增加
const UPDATE_EXPAND = "updateExpandStatus"; // 块操作 行操作-切换折叠状态


const OutConst = {
  DEMO,
  RESET_STATUS,

  CUSTOM_INIT,
  GET_FILTER,
  UPDATE_FILTERSTATUS,
  OPEN_SEARCH,
  OPT_ADD,
  UPDATE_EXPAND,
};

export default OutConst;
